import { LOGO_MEDIUM } from '@assets';
import { CustomizedButton } from '@components/Customized';
import NotificationContainer from '@components/Notification';
import { colorSet } from '@components/Provider';
import useClient from '@hooks/useClient';
import { AppBar, useMediaQuery, makeStyles, useTheme } from '@material-ui/core';
import CommonLayout from '@routes/Common/CommonLayout';
import GnbCheckerBoardMenu from '@routes/Common/CommonLayout/GnbCheckerBoardMenu';
import { useHistory } from 'react-router-dom';

import BlogIframe from './BlogIframe';

const useStyles = makeStyles(() => ({
  mobileAppBar: {
    background: colorSet.gray000,
    height: 48,
    position: 'sticky',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 16px',
    borderBottom: `1px solid ${colorSet.gray400}`,
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      gap: '14px'
    },
    '& .gnb-checkerboard-menu': {
      color: colorSet.gray900,
      '&:hover': {
        color: colorSet.gray900
      },
      transition: '0.3s ease-in-out'
    },
    '& .gnb-notification-icon': {
      '& span > svg': {
        color: colorSet.gray900,
        transition: '0.3s ease-in-out'
      },
      '&:hover': {
        '& span > svg': {
          color: colorSet.gray900
        }
      },
      transition: '0.3s ease-in-out'
    },
    '& .logoBtn': {
      minWidth: 65,
      minHeight: 18,
      background: `${`url(${LOGO_MEDIUM}) no-repeat`}`,
      backgroundSize: 'contain',
      transition: '0.3s ease-in-out'
    },
    '& .loginButton': {
      backgroundColor: colorSet.gray200,
      color: colorSet.gray900
    },
    '& .gnb-blog': {
      fontSize: '14px',
      fontWeigth: 500,
      color: colorSet.primary500,
      borderRadius: 0
    },
    transition: '0.3s ease-in-out'
  }
}));

const BlogPresenter = () => {
  const { clientState } = useClient();
  const { mobileAppBar } = useStyles();
  const history = useHistory();
  const isAuth = Boolean(clientState?.accessToken);
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));

  return (
    <>
      <CommonLayout gnbTabs={isAuth ? null : <></>} fullHeight={true}>
        {matches && (
          <AppBar className={mobileAppBar} elevation={0}>
            <CustomizedButton
              className="logoBtn"
              variant="text"
              onClick={() => history.push('/')}
            ></CustomizedButton>
            <div>
              <CustomizedButton
                className="gnb-blog"
                variant="text"
                onClick={() => {
                  history.push('/blog');
                }}
              >
                블로그
              </CustomizedButton>
              <GnbCheckerBoardMenu />
              {isAuth ? (
                <NotificationContainer />
              ) : (
                <CustomizedButton
                  variant="contained"
                  onClick={() => history.push('/login')}
                  size="small"
                  className="loginButton"
                >
                  로그인
                </CustomizedButton>
              )}
            </div>
          </AppBar>
        )}

        <BlogIframe />
      </CommonLayout>
    </>
  );
};

export default BlogPresenter;
